<ng-template #vergoedingen>
    <div class="h3">Hoe bepalen wij het bedrag dat wij uitkeren?</div>
    <p>
        Wij gebruiken het door u opgegeven aankoopbedrag van uw fiets inclusief accessoires en slot. Ook houden wij
        rekening met de ouderdom en slijtage van de fiets.
    </p>

    <p>Van het aankoopbedrag vergoeden wij dan:</p>
    <list-flat icon="dot" [svg]="true">
        <list-flat-item>100% in de eerste 3 jaar</list-flat-item>
        <list-flat-item>75% in het 4e jaar</list-flat-item>
        <list-flat-item>60% in het 5e jaar</list-flat-item>
        <list-flat-item>50% na het 5e jaar</list-flat-item>
    </list-flat>
    <p>Voor uw accu vergoeden we dan:</p>
    <list-flat icon="dot" [svg]="true">
        <list-flat-item>100% in de 1e jaar</list-flat-item>
        <list-flat-item>75% in het 2e jaar</list-flat-item>
        <list-flat-item>50% in het 3e jaar</list-flat-item>
        <list-flat-item>25% na het 3e jaar</list-flat-item>
    </list-flat>

    <p>
        Bovenop dat bedrag zijn accessoires die u koopt nadat u de verzekering gesloten hebt tot maximaal €&nbsp;200,-
        verzekerd.
    </p>
</ng-template>
<ng-template #voorwaarden>
    <!-- prettier-ignore -->
    <p>
        Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat
        <ins-pdf-link [pdfLink]="documentsEnum.ConditionsBicycleInsurance" pdfLinkTitle="Voorwaarden Fietsverzekering">in onze voorwaarden</ins-pdf-link>.
    </p>
</ng-template>

<ng-container *ngIf="coverageId === coverageIdEnum.FietsDiefstal">
    <cyno-tabset customClass="tabset tabset--dark">
        <cyno-tab tabTitle="Wel verzekerd" [active]="true">
            <p>
                Wij vergoeden schade aan uw fiets, accessoires en slot bij diefstal en poging tot diefstal overal ter
                wereld.
            </p>
            <p>
                Let op: u bent alleen verzekerd als uw fiets met een ART categorie 2-slot afgesloten is en u beide
                geregistreerde sleutels naar ons opstuurt. Bij een elektronisch slot moet het slot ook een E+ toevoeging
                hebben. Voor een racefiets en mountainbike gelden strengere eisen. Buiten moet het frame van uw fiets
                met een ART categorie 2-slot worden vastgemaakt aan een boom of lantaarnpaal of iets anders dat aan de
                grond verankerd is. In een afgesloten ruimte is uw fiets alleen verzekerd voor diefstal als er sporen
                van inbraak zijn.
            </p>
            <ng-container *ngTemplateOutlet="vergoedingen"></ng-container>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
        <cyno-tab tabTitle="Niet verzekerd">
            <p>Wij vergoeden geen schade aan uw fiets, accessoires en slot bij diefstal en poging tot diefstal als:</p>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>Uw fiets niet op slot stond met een ART categorie 2 slot</list-flat-item>
                <list-flat-item>
                    U niet de twee geregistreerde sleutels kunt laten zien (of een logfile bij een elektronisch slot)
                </list-flat-item>
                <list-flat-item>U uw fiets verhuurt</list-flat-item>
                <list-flat-item>
                    Uw fiets zakelijk gebruikt wordt (naar uw werk fietsen mag uiteraard wel)
                </list-flat-item>
                <list-flat-item>
                    Alleen fietscomputers en/of navigatieapparatuur van uw fiets gestolen worden
                </list-flat-item>
                <list-flat-item>
                    Uw racefiets of ATB gestolen is uit een niet afgesloten ruimte én deze niet vast stond met een ART
                    categorie 2-slot aan de vaste wereld (zoals een fietsenrek, buis of paal)
                </list-flat-item>
                <list-flat-item>
                    Uw racefiets of ATB gestolen is uit een afgesloten ruimte zonder sporen van braak
                </list-flat-item>
            </list-flat>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
        <cyno-tab tabTitle="Eigen Risico">
            <p>Uw eigen risico is: €&nbsp;0</p>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
    </cyno-tabset>
</ng-container>

<ng-container *ngIf="coverageId === coverageIdEnum.FietsAllrisk">
    <cyno-tabset customClass="tabset tabset--dark">
        <cyno-tab tabTitle="Wel verzekerd" [active]="true">
            <p>
                Wij vergoeden schade aan uw fiets, accessoires en slot bij diefstal, poging tot diefstal of ongeluk
                overal ter wereld. Het omwaaien, omvallen van uw fiets is ook verzekerd. Net als schade die u per
                ongeluk zelf maakt of als uw fiets in het water valt.
            </p>
            <p>
                Let op: u bent alleen verzekerd voor diefstal of een poging tot diefstal als uw fiets met een ART
                categorie 2-slot afgesloten is en u beide geregisteerde sleutels naar ons opstuurt. Bij een elektronisch
                slot moet het slot ook een E+ toevoeging hebben. Voor een racefiets en mountainbike gelden strengere
                eisen. Buiten moet het frame van uw fiets met een ART categorie 2-slot worden vastgemaakt aan een boom
                of lantaarnpaal of iets anders dat aan de grond verankerd is. In een afgesloten ruimte is uw fiets
                alleen verzekerd voor diefstal als er sporen van inbraak zijn.
            </p>
            <ng-container *ngTemplateOutlet="vergoedingen"></ng-container>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
        <cyno-tab tabTitle="Niet verzekerd">
            <p>Wij vergoeden geen schade aan uw fiets, accessoires en slot:</p>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>Als u uw fiets verhuurt</list-flat-item>
                <list-flat-item>
                    Als uw fiets zakelijk gebruikt wordt (naar uw werk fietsen mag uiteraard wel)
                </list-flat-item>
                <list-flat-item>Door slijtage, krassen of slecht onderhoud</list-flat-item>
            </list-flat>

            <p>Bij diefstal en poging tot diefstal vergoeden wij geen schade als:</p>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>Uw fiets niet op slot stond met een ART categorie 2 slot</list-flat-item>
                <list-flat-item>
                    U niet de twee geregistreerde sleutels kunt laten zien (of een logfile bij een elektronisch slot)
                </list-flat-item>
                <list-flat-item>
                    Alleen fietscomputers en/of navigatieapparatuur van uw fiets gestolen worden
                </list-flat-item>
                <list-flat-item>
                    Uw racefiets of ATB gestolen is uit een niet afgesloten ruimte én deze niet vast stond met een ART
                    categorie 2-slot aan de vaste wereld (zoals een fietsenrek, buis of paal)
                </list-flat-item>
                <list-flat-item>
                    Uw racefiets of ATB gestolen is uit een afgesloten ruimte zonder sporen van braak
                </list-flat-item>
            </list-flat>

            <p>Bij een ongeluk vergoeden vergoeden wij geen schade als:</p>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>Die ontstaan is tijdens een wedstrijd of race</list-flat-item>
                <list-flat-item>
                    Als de bestuurder van de fiets (die met uw toestemming op uw fiets rijdt) meer alcohol, drugs en/of
                    medicijnen heeft gebruikt dan van de wet mag
                </list-flat-item>
            </list-flat>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
        <cyno-tab tabTitle="Eigen Risico">
            <p>Uw eigen risico is: €&nbsp;0</p>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
    </cyno-tabset>
</ng-container>
